import React from 'react';
import { Route } from 'react-router';

import Layout from '../components/layout';
import AccountConnector from '../modules/account-connector';

export default () => (
  <Layout>
    <Route exact path='/:profileKey?' component={AccountConnector} />
  </Layout>
);



// WEBPACK FOOTER //
// ./src/app/index.js